import React, { useRef } from 'react'
import { useDownloadExcel } from 'react-export-table-to-excel';

export default function DownloadTable({ tableRef, template = null, sheetName = null, fileName = null }) {

    let [downloadFileName, downloadSheetName] = [null, null];

    if (template) {
        downloadFileName = `${template.municipio}_${template.categoria}_${template.mes}-${template.ano}`.toLowerCase();
        downloadSheetName = `${template.categoria}`;
    }
    else {
        downloadFileName = fileName;
        downloadSheetName = sheetName;
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: downloadFileName,
        sheet: downloadSheetName
    });

    return <>
        <a onClick={onDownload} className='btn btn-link text-muted' style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '13px' }}>
            <i className='zmdi zmdi-download' style={{ fontSize: '15px', }}></i> <small> DOWNLOAD </small>
        </a>
    </>
}